import { Component, ElementRef, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ComponentBase, UpcomingRegistrationNumberInfo } from 't4core';
import { T4DatatableWidget } from '../../../../t4common';
import { UploadObjectDialog } from '../../dialogs/UploadObject/UploadObject';
import { DeviceType } from '../../../../../projects/t4core/src/public-api';
import { Subscription } from 'rxjs';
import { FormControl } from '@angular/forms';

@Component({
  selector: 't4-upcoming-objects',
  templateUrl: './UpcomingObjects.component.html',
})
export class UpcomingObjectsComponent extends ComponentBase implements OnInit, AfterViewInit, OnDestroy {
  public upcomingObjects: UpcomingRegistrationNumberInfo[];
  public formattedUpcomingObjects: any[];
  public validationResult: any = null;
  public onlyConnected: boolean = true;
  public isLoading: boolean = false;
  private filterSubscription: Subscription;
  public txtFilter: FormControl = new FormControl();
  public showImportDevices: boolean = false;
  @ViewChild("txtFile") private txtFile: ElementRef;
  @ViewChild("tblUpcomingObjects", { static: false })


  private tblUpcomingObjects: T4DatatableWidget;
  constructor(el: ElementRef, private router: Router) {
    super();
  }

  async ngOnInit() {

  }
  async ngAfterViewInit() {
    await this.LoadUpcomingTrailers('');
    this.filterSubscription = this.tblUpcomingObjects.txtFilter.valueChanges.subscribe(async x => {
      await this.LoadUpcomingTrailers(x);
    });
  }

  ngOnDestroy() {
    if (this.filterSubscription) {
      this.filterSubscription.unsubscribe();
    }
  }

  public async LoadUpcomingTrailers(searchText: string) {
    var token = this.UI.beginLoading("T4.Settings.UpcomingObjects.msgLoading", "Loading objects", null);
    if (searchText == '') {
      this.tblUpcomingObjects.txtFilter.setValue('', { emitEvent: false });
    }
    this.upcomingObjects = await this.Api.get<UpcomingRegistrationNumberInfo[]>("Service/GetUpcomingTrailers", { searchText: searchText, limit: 100, onlyConnected: this.onlyConnected });
    if (this.upcomingObjects) {
      this.formattedUpcomingObjects = this.upcomingObjects.map(x => {
        return {
          Id: x.Id,
          SerialNo: x.SerialNo,
          Tracker: x.PendingDevices.filter(x => x.DeviceType == DeviceType.Tracker).map(d => d.SerialNo).join(" "),
          NFCTag: x.PendingDevices.filter(x => x.DeviceType == DeviceType.NfcTag).map(d => d.SerialNo).join(" "),
          DeviceNumber: x.PendingDevices.filter(x => x.DeviceType == DeviceType.DeviceNumber).map(d => d.SerialNo),
          ConnectedToT4: x.PendingDevices.some(d => d.IsT4Connected),
          T4ConnectedDate: x.PendingDevices.find(d => d.IsT4Connected && d.T4ConnectedDate)?.T4ConnectedDate ?? null
        }
      });
    }
    this.UI.loaderCompleted(token);
  }

  public ImportDevices() {
    this.showImportDevices = true;
    this.validationResult = null;
  }
  public beginUpload() {
    this.txtFile.nativeElement.click();
  }

  public async upload(files: FileList) {
    try {
      if (!files || files.length < 1) return;

      const file = files.item(0);
      this.validationResult = null;
      const validationResponse = await this.readValidationFromFile(file);
      this.validationResult = this.createValidationResult(validationResponse);
    }
    finally {
      this.txtFile.nativeElement.value = '';
    }
  }

  private async readValidationFromFile(file: File): Promise<any> {
    this.loading = true;
    try {
      const data = await this.readFileAsDataUrl(file);
      return await this.Api.post<any>("Service/ValidateUpcomingTrailers", JSON.stringify(data));
    }
    finally {
      this.loading = false;
    }
  }

  private async readFileAsDataUrl(file: File): Promise<string> {
    return await new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result?.toString() ?? '');
      reader.onerror = () => reject(reader.error);
      reader.readAsDataURL(file);
    });
  }

  private createValidationResult(response: any): any {
    const rows: any[] = Array.isArray(response?.rows) ? response.rows : [];
    const missingSerialNos = rows
      .filter((x: any) => !x?.Exists)
      .map((x: any) => x?.SerialNo)
      .filter((x: any) => !!x)
      .sort((a, b) => a.localeCompare(b));

    const missingConnectionsByTrailer = rows
      .filter((x: any) => x?.Exists && (!x?.HasTracker || !x?.HasNfcTag))
      .map((x: any) => {
        const missing: string[] = [];
        if (!x?.HasTracker) {
          missing.push('Tracker');
        }
        if (!x?.HasNfcTag) {
          missing.push('NFC Tag');
        }

        return {
          trailerSerialNo: x?.SerialNo,
          missing: missing
        };
      })
      .filter((x: any) => !!x?.trailerSerialNo)
      .sort((a, b) => a.trailerSerialNo.localeCompare(b.trailerSerialNo));

    return {
      message: response?.message,
      validatedSerialNos: rows.map((x: any) => x?.SerialNo).filter((x: any) => !!x),
      missingSerialNos: missingSerialNos,
      missingConnectionsByTrailer: missingConnectionsByTrailer
    };
  }
}
